module.exports = __webpack_public_path__ + "img/ico_2viaboleto.a91afb07.svg";